/* eslint-disable */
import { InputElementBase, InputElementBaseProperties } from "@episerver/forms-sdk";
// @ts-ignore
import React, { useEffect, useMemo, useRef, useState } from "react";
import ElementWrapper from "./shared/ElementWrapper";
import { useElement } from "../../hooks/useElement";
import { ValidationMessage } from "./shared";
import { DispatchFunctions } from "3-components/OptimizelyForm/context/dispatchFunctions";
import googleMapPlacesApiLoader from "3-components/OptimizelyForm/hooks/googleMapPlacesApiLoader";
import { useForms } from "3-components/OptimizelyForm/context/store";
import getFieldKey from "3-components/OptimizelyForm/helper/getFieldKey";
import getFieldKeyByType from "3-components/OptimizelyForm/helper/getFieldKeyByType";

interface AddressElementProps extends InputElementBaseProperties {
    country?: string;
}

interface AddressElement extends InputElementBase {
    properties: AddressElementProps;
}

export interface AddressElementBlockProps {
    element: AddressElement
}

export const AddressElementBlock = (props: AddressElementBlockProps) => {
    const { element } = props;
    const { elementContext, handleBlur, handleChange } = useElement(element);
    const { isVisible, validationResults, value, elementRef, validatorClasses, extraAttr } = elementContext;
    const dispatchFuncs = new DispatchFunctions();
    const formContext = useForms();

    // const [addressValue, setAddressValue] = useState();

    // get other fields key
    const addressFieldKey = getFieldKey(formContext, 'street-address');
    const countryFieldKey = getFieldKey(formContext, 'country-name');
    const stateFieldKey = getFieldKey(formContext, 'address-level1');
    const cityFieldKey = getFieldKey(formContext, 'address-level2');
    const postcodeFieldKey = getFieldKey(formContext, 'postal-code');

    const toggleAddressFieldKey = getFieldKeyByType(formContext, 'LinkToggleElementBlock');

    useEffect(() => {
        const initGooglePlacesAutocomplete = async () => {
            const places = await googleMapPlacesApiLoader();

            const country = element.properties.country ? element.properties.country.toLowerCase() : 'au';

            const options: google.maps.places.AutocompleteOptions = {
                componentRestrictions: { country },
                fields: ['address_components', 'geometry', 'icon', 'name'],
                strictBounds: false,
                types: ['address']
            };

            const placeAutocomplete = new places.Autocomplete(elementRef.current, options);

            placeAutocomplete.addListener('place_changed', () => {
                const place = placeAutocomplete.getPlace();

                let addressLine = '';
                let postcode = '';
                let state = '';
                let suburb = '';
                let country = '';

                if(!place.address_components){
                    return
                }

                for (const component of place.address_components) {
                    const componentType = component.types[0];

                    switch (componentType) {
                    case 'point_of_interest': {
                        addressLine = `${component.long_name}, ${addressLine}`;
                        break;
                    }

                    case 'subpremise': {
                        addressLine += `${component.long_name}/`;
                        break;
                    }

                    case 'street_number': {
                        addressLine += `${component.long_name} `;
                        break;
                    }

                    case 'route': {
                        addressLine += component.short_name;
                        break;
                    }

                    case 'postal_code': {
                        postcode = `${component.long_name}${postcode}`;
                        break;
                    }

                    case 'postal_code_suffix': {
                        postcode = `${postcode}-${component.long_name}`;
                        break;
                    }
                    case 'locality':
                        suburb = `${component.long_name}`;
                        break;
                    case 'administrative_area_level_1': {
                        state = component.short_name;
                        break;
                    }
                    case 'country': {
                        country = component.long_name;
                        break;
                    }

                    default:
                        break;
                    }
                }

                if(toggleAddressFieldKey) {
                    dispatchFuncs.updateValue(toggleAddressFieldKey, `yes`);
                }

                // update other fields submition value
                if( addressFieldKey ) {
                    dispatchFuncs.updateValue(addressFieldKey, addressLine); // update address value
                    dispatchFuncs.updateValidation(addressFieldKey, {
                        valid: true,
                        message: ''
                    });
                }

                if( countryFieldKey ) {
                    dispatchFuncs.updateValue(countryFieldKey, country); // update country value
                    dispatchFuncs.updateValidation(countryFieldKey, {
                        valid: true,
                        message: ''
                    });
                }

                if( stateFieldKey ) {
                    dispatchFuncs.updateValue(stateFieldKey, state); // update state value
                    dispatchFuncs.updateValidation(stateFieldKey, {
                        valid: true,
                        message: ''
                    });
                }

                if( cityFieldKey ) {
                    dispatchFuncs.updateValue(cityFieldKey, suburb); // update city / suburb value
                    dispatchFuncs.updateValidation(cityFieldKey, {
                        valid: true,
                        message: ''
                    });
                }

                if( postcodeFieldKey ) {
                    dispatchFuncs.updateValue(postcodeFieldKey, postcode); // update postcode
                    dispatchFuncs.updateValidation(postcodeFieldKey, {
                        valid: true,
                        message: ''
                    });
                }

                dispatchFuncs.updateValue(element.key, `${addressLine}, ${suburb} ${state}, ${country} ${postcode}`);
            });
        }

        initGooglePlacesAutocomplete();
    }, [elementRef]);

    return useMemo(()=>(
        <ElementWrapper className={`FormTextbox ${validatorClasses}`} validationResults={validationResults} isVisible={isVisible}>
            <label htmlFor={element.key} className="Form__Element__Caption">
                <span className="Form__Element__Caption_text">
                    {element.displayName}&#8204;
                </span>
            </label>
            <input type="text" className="FormTextbox__Input" 
                aria-describedby={`${element.key}_desc`}
                placeholder={`Start typing and we'll do the rest`}
                {...extraAttr}
                name={`${element.key}_lookup`}
                onBlur={handleBlur}
                ref={elementRef}
            />
            <input type="hidden" name={element.key} id={element.key} value={value} onChange={handleChange} />
            <ValidationMessage element={element} validationResults={validationResults} />

        </ElementWrapper>
    ), [isVisible, validationResults, value]);
}